module.exports = __webpack_public_path__ + "static/media/08_after.4b0c8cec.jpg";